module.exports = __webpack_public_path__ + "img/logo_ormis.ebc477ae.svg";